export class Logout {
    static readonly type = '[Auth] Logout';
}
